import { ApiService, LabOrder } from "pwapi";

import {
  COMPLETE_STAIN_ORDER_FAILURE,
  COMPLETE_STAIN_ORDER_REQUEST,
  COMPLETE_STAIN_ORDER_SUCCESS,
  DELETE_STAIN_ORDER_FAILURE,
  DELETE_STAIN_ORDER_REQUEST,
  DELETE_STAIN_ORDER_SUCCESS,
  LABORDERS_LIST_REQUEST,
} from "./constants";
import { createAsyncSaga, AsyncSagaAction } from "../utils/asyncActions";

export const fetchLabOrders = (payload: any) => {
  return {
    type: LABORDERS_LIST_REQUEST,
    payload,
  };
};

type CancelArgs = LabOrder;
export const cancelLabOrder = createAsyncSaga(
  DELETE_STAIN_ORDER_REQUEST,
  DELETE_STAIN_ORDER_SUCCESS,
  DELETE_STAIN_ORDER_FAILURE,
  ({ id }: CancelArgs) => {
    return `/stain-order/${id}/delete`;
  },
  ApiService.destroyLabOrder
) as AsyncSagaAction<CancelArgs>;

export const completeLabOrder = createAsyncSaga(
  COMPLETE_STAIN_ORDER_REQUEST,
  COMPLETE_STAIN_ORDER_SUCCESS,
  COMPLETE_STAIN_ORDER_FAILURE,
  (id: number) => {
    return `/stain-order/${id}/complete`;
  },
  (id: number) => ApiService.completeLabOrder({ id })
) as AsyncSagaAction<number>;
